import { useState, useContext, useEffect } from "react";
import { PopupContext } from "../components/LoginPopup/LoginPopupContext";
import Container from "../components/common/Container";

export default function Rulse() {
  document.title = "Rulse";
  const [grulesAcc, setGrulesAcc] = useState();
  const { grulesData, setGameRule } = useContext(PopupContext);

  const grulesAccHandle = (name) => {
    setGrulesAcc((prev) => (prev === name ? !prev : name));
  };

  const getData = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      whiteLabelName: window.location.hostname,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/getGameRules`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setGameRule(data);
        let list = data?.data
        if (list.length > 0) {
            grulesAccHandle(list[0].name);
        }
      })
      .catch((error) => {
        console.log("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Container size="full">
        <div className="content-full">
          <div className="home-grid-sec casino-grid-sec game-rules-popup fancy-popup ">
          <h2> Game Rules </h2>
            <div className="gr-accordian">
              {grulesData?.data?.map((item, index) => (
                <div key={index} className="gr-accordian-item">
                  <div
                    className={`gr-accordian-title ${grulesAcc === item.name ? "active" : ""}`}
                    onClick={() => grulesAccHandle(item.name)}
                  >
                    {item.name}{" "}
                    <svg
                    width={"15px"}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      fill="#212529"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                      />
                    </svg>
                  </div>
                  <div
                    className={`gr-accordian-content ${grulesAcc === item.name ? "active" : ""}`}
                  >
                    {" "}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
